import { get, post, put, del } from "../../httpClients/clients/http.client";

const BASE_PATH = "/parameter";

export const ParameterApi = {
  getValue: (name: string, signal?: AbortSignal): Promise<{ value: string }> =>
    get(`${BASE_PATH}/${name}`, {
      signal,
    }),
  putValue: (
    token: string,
    name: string,
    value: string,
    signal?: AbortSignal
  ): Promise<{ value: string }> =>
    put(
      `${BASE_PATH}/${name}`,
      { parameterValue: value },
      {
        headers: { Authorization: `Bearer ${token}` },
        signal,
      }
    ),
};
